import Vue from "vue";

const ComponentProps = Vue.extend({
  props: {
    opened: {
      type: Boolean,
      required: false,
    },

    hasCloseButton: {
      type: Boolean,
      default: true,
    },

    side: {
      type: String,
      default: "right", //left
    },
  },
});

export default ComponentProps;
